import React from "react"
import { Translate } from "utils/i18n-shim"
import { Stack } from "@mui/material"

import { Autocomplete } from "shared/ui/berry-jass"
import { TagsField } from "./TagsField"

export const CampaignTags = ({ japCustomerId, atsTags }) => {
  return (
    <Stack direction="column" spacing={2}>
      <Autocomplete
        multiple
        freeSolo
        readOnly
        options={atsTags}
        value={atsTags}
        label={<Translate value="campaigns.ats-tags" />}
      />

      <TagsField japCustomerId={japCustomerId} />
    </Stack>
  )
}
